module.exports = __webpack_public_path__ + "img/loader.791bd78e.gif";